import React from 'react';
import Card from 'components/common/Card';
import PaymentMethodItem from 'components/payment/PaymentMethodItem';
import Row from 'components/common/Skeleton';
import { country } from 'consts';
import useWindowSize from 'lib/hooks/useWindowSize';
import { getEnvironment } from 'config';

function Skeleton(): JSX.Element {
    const {
        app: { enableNewPaymentMethods },
    } = getEnvironment();

    return (
        <Card title={enableNewPaymentMethods ? 'Elige como pagar' : 'Medio de Pago'}>
            <div style={{ paddingTop: '1.5em' }}>
                {country == 'CL' ? (
                    <>
                        <Item />
                        <Item />
                        <Item />
                        <Item />
                    </>
                ) : (
                    <>
                        <Item />
                        <Item />
                    </>
                )}
            </div>
        </Card>
    );
}

function Item(): JSX.Element {
    const [width] = useWindowSize();
    const isMobile = width <= 768;

    return (
        <PaymentMethodItem
            paymentMethodName=""
            type="credito"
            widthIcon="63px"
            onClick={() => {}}
            additionalInfo={<Row width={isMobile ? 90 : 50} />}
            disabled
            blocked
        />
    );
}

export default Skeleton;
